module.exports = __webpack_public_path__ + "img/wechatpay-alternative.54e54b5c.png";